export const DATABASE_ROUTE_NAMES = {
  databaseProducers: 'accDatabaseProducers',
  databaseProducersDuplicates: 'accDatabaseProducersDuplicates',
  databaseBrands: 'accDatabaseBrands',
  databaseWines: 'accDatabaseWines',
  databaseGeoIndication: 'accDatabaseGeoIndication',
  databaseExhibitions: 'accDatabaseExhibitions',
  databaseAwards: 'accDatabaseAwards',
  databaseKindOfWine: 'accDatabaseKindOfWine',
  databaseSpecClasCondition: 'accDatabaseSpecialClassificationCondition',
}

export const databaseTableNames = {
  producers: 'producers',
  producersDuplicates: 'producersDuplicates',
  brands: 'brands',
  wines: 'wines',
  awards: 'awards',
  geoIndication: 'geo-indication',
  exhibitions: 'exhibitions',
  kindOfWine: 'kind-of-wine',
  specialClassificationCondition: 'special-classification-condition',
}
